import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LabelService } from '../../shared/services/label.service';
import { EventBus } from '../../shared/utils/eventbus';

@Component({
  selector: 'app-resetform',
  templateUrl: 'reset.form.component.html',
})
export class ResetFormComponent {
  @Input() buttonStyle = '';
  @Output() resetFilter = new EventEmitter();

  public CLEAR_FILTER_LABEL: string;

  constructor(
    private labelService: LabelService,
    private eventBus: EventBus,
  ) {
    this.CLEAR_FILTER_LABEL = labelService.getLabel('wisFilterLabel');
  }

  public clearForm(): boolean {
    this.resetFilter.emit();
    this.eventBus.emit('filterApp.clearFilter');
    return false;
  }
}
